import { t } from '@lingui/macro';
import { message, Upload } from 'antd';
import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { UploadLightboxFileManagerContext } from '../context';
import { IMAGE_ACCEPT_EXTENSIONS } from '../constants';
import { ImageWithMask } from './ImageWithMask';

const apiUrl = process.env.REACT_APP_PROXY_API_URL;

export function DragNDropUpload() {
    const { setStates, props } = useContext(UploadLightboxFileManagerContext);

    const {
        setFileUrl,
        setComponentFile,
        setUploading,
    } = setStates;

    const {
        //antd
        onChange,
        // parent
        fileTypeFilter,
        disabled,
        overrideUploadProps,
        acceptedMimes,
        // onUpload,
    } = props;

    const selectorFn = state => ({
        accessToken: state.Auth.accessToken,
        subdomain: state.Auth.subdomain,
    });
    const {
        accessToken,
        subdomain,
    } = useSelector(selectorFn, shallowEqual);
    const fileLimitMB = 10;

    // Build header with authorisation & stuffs.
    const getHeaders = () => {
        const headers = {};
        if (accessToken)
            headers.Authorization = `Bearer ${accessToken}`;
        if (subdomain)
            headers['Company-Subdomain'] = subdomain;
        return headers;
    };
    // Do checking following the rules.
    const beforeUpload = file => {
        if (acceptedMimes && acceptedMimes.indexOf(file.type) === -1) {
            message.error(t`The file type is blocked for this upload.`);
            return false;
        }

        if ((file.size / 1024 / 1024) > fileLimitMB) {
            message.error(t`The file exceed the file size limit at ${fileLimitMB} MB.`);
            return false;
        }
        return true;
    };

    const onUploadChange = info => {
        console.log('aaa onUploadChange', info);
        if (info.file.status === 'uploading') {
            setUploading(true);
        }
        else if (info.file.status === 'done') { // Done
            const uploadResponseFile = info.file.response.file;
            // onUpload({ file: uploadResponseFile });

            if (onChange) // Antd Built-in onChange (Form.Item)
                onChange(uploadResponseFile.id);

            setFileUrl(uploadResponseFile.url);
            setComponentFile({
                file: uploadResponseFile,
                id: uploadResponseFile.id,
                file_id: uploadResponseFile.id,
            });
            setUploading(false);
        }
    };
    const uploadProps = {
        accept: fileTypeFilter === 'IMAGE' ? IMAGE_ACCEPT_EXTENSIONS : undefined,
        headers: getHeaders(),
        action: `${apiUrl}/files`,
        beforeUpload,
        onChange: onUploadChange,
    };
    return (
        <Upload
            className={`bukku-upload ${disabled ? 'disabled' : ''}`}
            openFileDialogOnClick={false}
            listType="picture-card"
            showUploadList={false}
            {...uploadProps}
            {...overrideUploadProps}
        >
            <ImageWithMask />
        </Upload>
    );
}
